import { forgotPasswordApi } from './forgotPasswordApi';

export const { useForgotPasswordMutation } = forgotPasswordApi;

export { forgotPasswordApi };
